import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { useState } from "react";
import { errorText } from "../api";
import { useSession } from "../session";

/**
 * Platform operasyonu bir mağazanın verisine yalnızca gerekçeli, süreli ve salt okunur bir destek oturumuyla erişir;
 * açılış audit'e mağaza tarafında görünür şekilde yazılır (ADR 005).
 */
export function SupportPage() {
  const openSupport = useSession((s) => s.openSupport);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(v: { tenantId: string; reason: string }) {
    setBusy(true);
    setError(null);
    try {
      await openSupport(v.tenantId.trim(), v.reason.trim());
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card title="Destek oturumu aç" style={{ maxWidth: 560 }}>
      <Typography.Paragraph type="secondary">
        Oturum 60 dakika sürer ve salt okunurdur. Gerekçe mağazanın audit kayıtlarında görünür.
      </Typography.Paragraph>
      {error && <Alert type="error" title={error} showIcon style={{ marginBottom: 16 }} />}
      <Form layout="vertical" onFinish={submit}>
        <Form.Item label="Mağaza kimliği" name="tenantId" rules={[{ required: true, max: 64 }]}>
          <Input placeholder="teknomarket" />
        </Form.Item>
        <Form.Item label="Gerekçe" name="reason" rules={[{ required: true, min: 10, max: 500, message: "En az 10 karakter" }]}>
          <Input.TextArea autoSize={{ minRows: 3 }} placeholder="Destek talebi #1234: katalog senkronu hatası" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={busy}>Oturumu aç</Button>
      </Form>
    </Card>
  );
}
